import BigNumber from 'bignumber.js';

import { CONFIDENTIAL_BALANCE_MAGIC_VALUE, ZERO } from 'lib/consts';

interface Params {
  value: string;
  exchangeRate?: string | null;
  accuracy?: number;
  accuracyUsd?: number;
  decimals?: string | null;
}

export default function getCurrencyValue({ value, accuracy, accuracyUsd, decimals, exchangeRate }: Params) {
  if (value === CONFIDENTIAL_BALANCE_MAGIC_VALUE) {
    return { valueStr: 'Encrypted', usd: undefined, usdBn: ZERO };
  }

  const valueCurr = BigNumber(value).div(BigNumber(10 ** Number(decimals || '18')));
  const powTransactionLimit = 1e27;

  let valueResult: string | undefined;
  if (Number(valueCurr) > powTransactionLimit) {
    valueResult = valueCurr.toExponential(5);
  } else {
    valueResult = accuracy ? valueCurr.dp(accuracy).toFormat() : valueCurr.toFormat();
  }

  let usdResult: string | undefined;
  let usdBn = ZERO;

  if (exchangeRate) {
    const exchangeRateBn = new BigNumber(exchangeRate);
    usdBn = valueCurr.times(exchangeRateBn);
    if (accuracyUsd && !usdBn.isEqualTo(0)) {
      const usdBnDp = usdBn.dp(accuracyUsd);
      usdResult = usdBnDp.isEqualTo(0) ? usdBn.precision(accuracyUsd).toFormat() : usdBnDp.toFormat();
    } else {
      usdResult = usdBn.toFormat();
    }
  }

  return { valueStr: valueResult, usd: usdResult, usdBn };
}
